function oneClickBuy() {
    const form = document.querySelector('.js-form-buy-click');

    if (!form || form.dataset['init'] === 'true') return;

    //чтобы запрос не уходил несколько раз
    let lock = false;

    // Галочка согласия есть только у гостя (её рендерит шаблон формы): пока она
    // не отмечена, отправлять нечего — кнопка заблокирована, как в попапе гарантии.
    const agree = form.querySelector('.js-buy-click-agree');
    const submitBtn = form.querySelector('[type="submit"]');

    if (agree && submitBtn) {
        const syncSubmit = function () {
            submitBtn.disabled = !agree.checked;
        };

        agree.addEventListener('change', syncSubmit);
        syncSubmit();
    }

    form.addEventListener('submit', function (e) {
        e.preventDefault();

        const tel = form.querySelector('.js-input-tel');

        if (tel.value.length !== 18) return;

        // Страховка на случай submit мимо кнопки (Enter в поле): без согласия
        // гостя учётку заводить нельзя.
        if (agree && !agree.checked) return;

        documentPreloaderStart();

        window.getCaptcha(form).then(async function () {
            let formData = new FormData(form);

            let dataFastOrder = {
                productId: $('[href="#buy-click"]').data('element-id'),
                name: formData.get('name'),
                phone: formData.get('phone'),
            };

            const createOrder = function () {
                if (lock) return;
                lock = true;

                // Заказ собирается не мгновенно (корзина, доставка, письма) —
                // без оверлея после ввода кода человек смотрит в тишину.
                documentPreloaderStart();

                BX.ajax.runComponentAction('ibrush:fast.order', 'createOrder', {
                    mode: 'class',
                    data: dataFastOrder
                }).then(responseHandler, function (response) {
                    console.log(response);
                    lock = false;
                    documentPreloaderEnd();
                });
            };

            if (form.getAttribute('action')) {
                // Токен капчи невидимый виджет кладёт в форму сам (smart-token),
                // sessid единый экшен требует явно — в URL его больше нет.
                const body = new FormData(form);
                body.append('sessid', BX.bitrix_sessid());
                // Обязательность согласия решает сервер (посайтовая опция
                // verify_consent_required), сюда идёт фактическое состояние галочки.
                body.append('consent', agree && agree.checked ? 'Y' : 'N');

                const response = await fetch(e.target.action, {
                    method: 'POST',
                    body: body
                })

                const data = await response.json()

                if (response.ok) {
                    if (data.status === 'success') {
                        const sent = data.data || {};

                        // Дальше человек вводит код — оверлей ему только мешает.
                        documentPreloaderEnd();

                        modals.closeModal(null, '#buy-click');

                        // Ввод кода — единая форма подтверждения (#phone-confirm):
                        // повтор и проверка идут на экшены itpragma:kupper.Auth.*,
                        // подтверждение авторизует владельца номера, после чего
                        // оформляется заказ.
                        window.msPhoneConfirm.open({
                            scenario: 'auth',
                            phone: String(formData.get('phone') || tel.value).replace(/\D/g, ''),
                            masked: sent.masked || tel.value,
                            resendInterval: sent.resendInterval || 60,
                            message: sent.channelMessage || '',
                            // Без экрана успеха: заказ уходит сразу после сверки
                            // кода — как делал прежний попап на проде.
                            skipSuccess: true,
                            onSuccess: createOrder,
                            onBack: function () {
                                modals.openModal(null, '#buy-click');
                            }
                        });
                    } else {
                        documentPreloaderEnd();

                        if (data.errors) {
                            modalMessage(data.errors[0].message, 'Обновите страницу или попробуйте позже');
                        }
                    }
                } else {
                    documentPreloaderEnd();
                }
            } else {
                createOrder();
            }
        }).catch(function (error) {
            console.error(error);
            documentPreloaderEnd();
        });
    });

    form.dataset['init'] = true;

    function responseHandler(response) {
        if (response.status === 'success' && response.data && response.data.status) {
            window.location = response.data.link
        } else {
            // Молчаливый отказ выглядел как «ничего не произошло», и человек
            // жал кнопку заново. Показываем причину, замок с формы снимаем.
            lock = false;
            documentPreloaderEnd();

            const reason = (response && response.data && response.data.error)
                || (response && response.errors && response.errors[0] && response.errors[0].message)
                || 'Обновите страницу и попробуйте ещё раз';

            modalMessage('Не удалось оформить заказ', reason);
        }

        YaMetrika.oneClickBuyTrigger();
    }
}
